<template>
  <div class="home">
    <v-row>
      <v-col>
        <v-card tile flat class="bg-card">
          <v-card-text class="pa-0">
            <v-row no-gutters>
              <v-col cols="12" class="pa-5">
                <h1 class="headline black--text">DIKLAT BERJENJANG GTK PAUD</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-alert v-if="is_kesediaan" class="my-4" prominent color="orange" text icon="mdi-information">
      <v-row>
        <v-col class="grow black--text">
          <div class="font-weight-bold">KONFIRMASI KESEDIAAN DIKLAT DARING</div>
          <span>
            Anda telah ditambahkan di kelas sebagai
            <template v-if="filteredGroup.length">
              <b v-for="(group, g) in filteredGroup" :key="group.value">
                {{ group.text === 'Admin Kelas' ? group.text : 'Pengajar' }}
                <span v-if="g + 1 !== filteredGroup.length">, </span>
              </b>
            </template>
            <template v-else> (<b>Pengajar, Pengajar Tambahan atau Pembimbing</b>) </template>
            <br />
            Silakan untuk melakukan konfirmasi kesediaan
          </span>
        </v-col>
        <v-col class="shrink">
          <v-btn class="mt-4" color="orange" depressed dark @click="onKonfirmasi(true, 'daring')">konfirmasi</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert v-if="is_kesediaan_luring" class="my-4" prominent color="blue" text icon="mdi-information">
      <v-row>
        <v-col class="grow black--text">
          <div class="font-weight-bold">KONFIRMASI KESEDIAAN DIKLAT LURING</div>
          <span>
            Anda telah ditambahkan di kelas sebagai
            <template v-if="filteredGroup.length">
              <b v-for="(group, g) in filteredGroup" :key="group.value">
                {{ group.text }}
                <span v-if="g + 1 !== filteredGroup.length">, </span>
              </b>
            </template>
            <template v-else> (<b>Pengajar, Pengajar Tambahan atau Pembimbing</b>) </template>
            <br />
            Silakan untuk melakukan konfirmasi kesediaan
          </span>
        </v-col>
        <v-col class="shrink">
          <v-btn class="mt-4" color="blue" depressed dark @click="onKonfirmasi(true, 'luring')">konfirmasi</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert v-if="is_kesediaan_petugas_bcmp" class="my-4" prominent color="blue" text icon="mdi-information">
      <v-row>
        <v-col class="grow black--text">
          <div class="font-weight-bold">KONFIRMASI KESEDIAAN BIMTEK BCMP</div>
          <span>
            Anda telah ditambahkan di kelas sebagai <b>Pengajar</b>, silakan untuk melakukan konfirmasi kesediaan
          </span>
        </v-col>
        <v-col class="shrink">
          <v-btn class="mt-4" color="blue" depressed dark @click="onKonfirmasi(true, 'bcmp_petugas')">konfirmasi</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert v-if="is_kesediaan_peserta_bcmp" class="my-4" prominent color="blue" text icon="mdi-information">
      <v-row>
        <v-col class="grow black--text">
          <div class="font-weight-bold">KONFIRMASI KESEDIAAN BIMTEK BCMP</div>
          <span>
            Anda telah ditambahkan di kelas sebagai <b>Peserta</b>, silakan untuk melakukan konfirmasi kesediaan
          </span>
        </v-col>
        <v-col class="shrink">
          <v-btn class="mt-4" color="blue" depressed dark @click="onKonfirmasi(true, 'bcmp_peserta')">konfirmasi</v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-row>
      <template v-for="(menu, i) in menus">
        <template v-if="menu.program">
          <v-col cols="12" md="12" lg="12" class="pa-3" :key="i" v-if="$akseses(menu, 'menu').length">
            <div class="headline" v-html="menu.program" />
            <v-divider class="py-3" />
            <v-row>
              <template v-for="(child, c) in menu.menu">
                <v-col cols="12" md="4" lg="4" :key="c" v-if="$allow(child.akses)">
                  <base-card-menus v-bind="child" @action="onAction" :key="c" />
                </v-col>
              </template>
            </v-row>
          </v-col>
        </template>
        <template v-else>
          <template v-for="(child, c) in menu.menu">
            <v-col cols="12" md="4" lg="4" :key="c" v-if="$allow(child.akses)">
              <base-card-menus v-bind="child" @action="onAction" :key="c" />
            </v-col>
          </template>
        </template>
      </template>
    </v-row>

    <base-modal-full ref="modal" title="Konfirmasi Kesediaan" :useSave="false">
      <form-ketersediaan
        :items="data"
        :jenis="jenis"
        :included="included"
        ref="ketersediaan"
        @reload="onKonfirmasi(false, jenis)"
      />
    </base-modal-full>
    <form-reupload ref="reupload" :berkases="berkases" @reload="onReload" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseCardMenus from '@/components/base/BaseCardMenus';
import FormKetersediaan from './components/Ketersediaan';
import FormReupload from './components/Reupload';

export default {
  name: 'home',
  components: {
    FormReupload,
    BaseCardMenus,
    FormKetersediaan,
  },
  data() {
    return {
      data: [],
      jenis: '',
      included: [],
    };
  },
  computed: {
    ...mapState('preferensi', {
      is_kesediaan: (state) => state?.data.konfirmasi_kesediaan ?? false,
      is_kesediaan_luring: (state) => state?.data.konfirmasi_kesediaan_luring ?? false,
      is_kesediaan_petugas_bcmp: (state) => state?.data.konfirmasi_kesediaan_petugas_bcmp ?? false,
      is_kesediaan_peserta_bcmp: (state) => state?.data.konfirmasi_kesediaan_peserta_bcmp ?? false,
      is_kesediaan_peserta_refreshment: (state) => state?.data.konfirmasi_kesediaan_peserta_refreshment ?? false,
      is_kesediaan_petugas_refreshment: (state) => state?.data.konfirmasi_kesediaan_petugas_refreshment ?? false,
      groups: (state) => state?.data?.groups ?? {},
      unggahan: (state) => state?.data?.unggahan ?? [],
    }),

    menus() {
      return this.$store.state.menus || [];
    },

    filteredGroup() {
      return this.$mapForMaster(this.groups).filter((s) => [175, 176, 174].includes(s.value)) || [];
    },

    berkases() {
      return this.unggahan.reduce((item, product) => {
        const { group } = product;
        item[group] = item[group] ?? [];
        item[group].push(product);
        return item;
      }, {});
    },
  },
  mounted() {
    if (this.unggahan.length) {
      this.$refs.reupload.open();
    }
  },
  methods: {
    ...mapActions('petugasKonfirmasi', ['fetch']),
    ...mapActions('preferensi', ['getPreferensi']),

    onAction({ action }) {
      switch (action) {
        default:
          break;
      }
    },

    async onKonfirmasi(status = false, jenis) {
      const resp = await this.fetch(jenis);
      this.$set(this, 'data', (resp && resp.data) || []);
      this.$set(this, 'jenis', jenis);
      this.$set(this, 'included', (resp && resp.included) || []);
      if (status) this.$refs.modal.open();
    },

    onReload() {
      this.getPreferensi(true);
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #ffab91;
  height: 100%;
}
</style>
